import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1ccc4816")

_pushScopeId("data-v-1ccc4816")
const _hoisted_1 = { class: "updateltlorder" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "updateltlorder__state"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "state__text" }, "Загрузка данных о заказе...", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "state__text failed" }, " Произошла ошибка при загрузке данных о заказе, попробуйте ещё раз ", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Перезагрузить")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_s_button = _resolveComponent("s-button")!
  const _component_order_progress = _resolveComponent("order-progress")!
  const _component_ltl_invoices = _resolveComponent("ltl-invoices")!
  const _component_ltl_receivers_panel = _resolveComponent("ltl-receivers-panel")!
  const _component_ltl_receiver = _resolveComponent("ltl-receiver")!
  const _component_ltl_cargo_payment = _resolveComponent("ltl-cargo-payment")!
  const _component_success_order = _resolveComponent("success-order")!
  const _component_s_modal = _resolveComponent("s-modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h2", _hoisted_2, "Добавление накладных в заказ " + _toDisplayString(_ctx.$route.params.order_id), 1),
    (!_ctx.state.is_loaded)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_4,
                _createVNode(_component_s_loader)
              ], 64))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_5,
                  _createVNode(_component_s_button, {
                    class: "primary",
                    onClick: _ctx.loadOrder
                  }, {
                    default: _withId(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.is_loaded)
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (Boolean(_ctx.state.order))
            ? (_openBlock(), _createBlock(_component_order_progress, {
                key: 0,
                isLTL: "",
                sender: _ctx.state.order.sender,
                "send-date": _ctx.state.order.take_date,
                "send-period": _ctx.state.order.period,
                blocked: true,
                "additional-services": null,
                "is-additional-services-setted": false
              }, null, 8, ["sender", "send-date", "send-period"]))
            : _createCommentVNode("", true),
          (_ctx.state.order_invoices.length > 0)
            ? (_openBlock(), _createBlock(_component_ltl_invoices, {
                key: 1,
                invoices: _ctx.state.order_invoices,
                blocked: true,
                title: "Грузы",
                isLTL: "",
                "without-header-and-footer": "",
                "is-update": ""
              }, null, 8, ["invoices"]))
            : _createCommentVNode("", true),
          (
                    !Boolean(_ctx.receivers_state.receiver) &&
                    !_ctx.state.is_complete_loading &&
                    !_ctx.state.is_completed
                )
            ? (_openBlock(), _createBlock(_component_ltl_receivers_panel, {
                key: 2,
                opened: true,
                loading: _ctx.receivers_state.is_loading,
                failed: _ctx.receivers_state.is_failed,
                receivers: _ctx.receivers_state.list,
                current_page: _ctx.receivers_state.pagination.current_page,
                total_pages: _ctx.receivers_state.pagination.total_pages,
                "is-search": _ctx.receivers_state.is_search,
                "selected-receivers-ids": _ctx.receivers_state.selected_ids,
                "sender-city-id": _ctx.senderCityId,
                blocked: _ctx.state.is_completed,
                isLTL: "",
                "disable-excel": "",
                onLoadmore: _ctx.loadMoreReceivers,
                onSearch: _ctx.searchReceiver,
                onSelect: _ctx.selectReceiver,
                onDelete: _ctx.deleteReceiver
              }, null, 8, ["loading", "failed", "receivers", "current_page", "total_pages", "is-search", "selected-receivers-ids", "sender-city-id", "blocked", "onLoadmore", "onSearch", "onSelect", "onDelete"]))
            : _createCommentVNode("", true),
          (
                    Boolean(_ctx.receivers_state.receiver) &&
                    !_ctx.state.is_complete_loading &&
                    !_ctx.state.is_completed
                )
            ? (_openBlock(), _createBlock(_component_ltl_receiver, {
                key: 3,
                receiver: _ctx.receivers_state.receiver,
                onReset: _ctx.resetReceiver
              }, null, 8, ["receiver", "onReset"]))
            : _createCommentVNode("", true),
          (!_ctx.state.is_completed && !_ctx.state.is_complete_loading)
            ? (_openBlock(), _createBlock(_component_ltl_cargo_payment, {
                key: 4,
                opened: Boolean(_ctx.receivers_state.receiver),
                "receiver-city-type": _ctx.receivers_state.receiver ? _ctx.receivers_state.receiver.city_type : null,
                onAddInvoice: _ctx.addInvoice
              }, null, 8, ["opened", "receiver-city-type", "onAddInvoice"]))
            : _createCommentVNode("", true),
          (_ctx.state.new_invoices.length > 0)
            ? (_openBlock(), _createBlock(_component_ltl_invoices, {
                key: 5,
                invoices: _ctx.state.new_invoices,
                loading: _ctx.state.is_complete_loading,
                blocked: _ctx.state.is_completed,
                "order-id": _ctx.$route.params.order_id,
                title: "Новые грузы",
                isLTL: "",
                "is-update": "",
                onCreate: _ctx.complete,
                onDelete: _ctx.removeInvoice
              }, null, 8, ["invoices", "loading", "blocked", "order-id", "onCreate", "onDelete"]))
            : _createCommentVNode("", true),
          (_ctx.modal_state.is_opened)
            ? (_openBlock(), _createBlock(_component_s_modal, {
                key: 6,
                class: "ltl",
                onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modal_state.is_opened = false))
              }, {
                body: _withId(() => [
                  _createVNode(_component_success_order, {
                    "order-id": _ctx.$route.params.order_id,
                    "is-update": ""
                  }, null, 8, ["order-id"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
})